import Select from "../../../form/select"
import DatePicker from "../../../date-picker"
import { SelectOptions } from "../../../../../types"

type Props = {
  range: "last_five" | "custom"
  setRange: (v: "last_five" | "custom") => void
  startDate: Date | null
  endDate: Date | null
  setStartDate: (d: Date | null) => void
  setEndDate: (d: Date | null) => void
  options: SelectOptions
}

export default function DateFilters({
  range,
  setRange,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  options
}: Props) {
  return (
    <div className="flex items-center">
      <span className="mr-4">Showing quotes of</span>
      <div className="w-60">
        <Select
          label=""
          IDkey="id"
          data={options}
          selected={range}
          setSelected={setRange}
        />
      </div>
      {range === "custom" && (
        <div className="ml-6 flex-1">
          <div className="flex items-center">
            <div className="mr-3 whitespace-nowrap">Start date</div>
            <div>
              <DatePicker
                aria-label="Start date"
                selected={startDate}
                onChange={setStartDate}
              />
            </div>
            <div className="mx-3 whitespace-nowrap">End date</div>
            <div>
              <DatePicker
                aria-label="End date"
                selected={endDate}
                onChange={setEndDate}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
